import Seo from "@/components/Seo";
import { FadeUp, ChapterLabel } from "@/components/Reveal";
import { useSiteData, defaultSettings } from "@/api";

const Bloc = ({ titre, children }) => (
  <FadeUp className="border-b border-ink/10 pb-12">
    <h2 className="font-serif text-2xl tracking-tight sm:text-3xl">{titre}</h2>
    <div className="mt-6 space-y-3 text-sm leading-relaxed text-bark md:text-base">{children}</div>
  </FadeUp>
);

const Confidentialite = () => {
  const site = useSiteData({ chantiers: null, services: null, settings: defaultSettings });
  const s = site.settings || defaultSettings;

  return (
    <>
      <Seo
        title="Politique de confidentialité — Alexis Peinture"
        description="Comment Alexis Peinture collecte et traite vos données personnelles via le formulaire de demande de devis."
      />
      <section className="mx-auto max-w-4xl px-6 pb-32 pt-40 lg:pt-48">
        <ChapterLabel number="—" label="Vos données" />
        <FadeUp delay={0.1}>
          <h1 className="mt-8 font-serif text-4xl tracking-tight sm:text-5xl" data-testid="confidentialite-title">
            Politique de <em className="italic text-clay">confidentialité</em>
          </h1>
        </FadeUp>

        <div className="mt-16 space-y-12">
          <Bloc titre="Responsable du traitement">
            <p>
              {s.gerant} — {s.entreprise} —{" "}
              <a href={`mailto:${s.email}`} className="text-clay underline-offset-2 hover:underline">
                {s.email}
              </a>{" "}
              — {s.telephone}.
            </p>
          </Bloc>

          <Bloc titre="Données collectées">
            <p>
              Via le formulaire de demande de devis : nom, numéro de téléphone,
              adresse email, ville, type de prestation souhaitée, description de
              votre besoin et, si vous le souhaitez, des photos de votre chantier.
            </p>
            <p>
              Ces informations servent uniquement à vous recontacter et à établir
              votre devis. Elles ne sont ni vendues, ni partagées avec des tiers
              à des fins commerciales.
            </p>
          </Bloc>

          <Bloc titre="Base légale et durée de conservation">
            <p>
              Le traitement repose sur votre demande explicite (mesures
              précontractuelles). Les demandes non abouties sont conservées au
              maximum 12 mois, puis supprimées.
            </p>
          </Bloc>

          <Bloc titre="Vos droits">
            <p>
              Conformément au RGPD, vous disposez d'un droit d'accès, de
              rectification, d'effacement et d'opposition concernant vos données.
              Pour l'exercer, écrivez à{" "}
              <a href={`mailto:${s.email}`} className="text-clay underline-offset-2 hover:underline">
                {s.email}
              </a>{" "}
              ou appelez le {s.telephone}.
            </p>
            <p>
              Vous pouvez également introduire une réclamation auprès de la CNIL
              (cnil.fr).
            </p>
          </Bloc>

          <Bloc titre="Cookies">
            <p>
              Ce site n'utilise pas de cookies de suivi ou publicitaires. Une
              session technique est utilisée uniquement pour l'espace
              d'administration.
            </p>
          </Bloc>
        </div>
      </section>
    </>
  );
};

export default Confidentialite;
